import type { IDocument } from "@bbj-types/document";
import type { ObjectId } from "@bbj-types/utils";
import { Loading } from "@surfaces/Loading";
import { type Dispatch, type SetStateAction, useEffect, useState } from "react";

interface IMailPreviewProps {
  template: IDocument | null;
  templatePreviewLoading: boolean;
  setTemplatePreviewLoading: Dispatch<SetStateAction<boolean>>;
  getMailPreview: (templateId: ObjectId) => Promise<string | undefined>;
}

export const MailPreview = ({
  template,
  templatePreviewLoading,
  setTemplatePreviewLoading,
  getMailPreview,
}: IMailPreviewProps) => {
  const [templateURL, setTemplateURL] = useState<string | undefined>();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (template) {
      const setTemplateURLPreview = async () => {
        setTemplatePreviewLoading(true);
        const url = await getMailPreview(template._id);
        if (url) {
          const documentFetch = await fetch(url);
          const blob = await documentFetch.blob();
          setTemplateURL(URL.createObjectURL(new Blob([blob], { type: "application/pdf" })));
        }
        setTemplatePreviewLoading(false);
      };
      setTemplateURLPreview();
    } else {
      setTemplateURL(undefined);
    }
  }, [template]);

  return (
    <Loading loading={templatePreviewLoading}>
      {templateURL && (
        <embed
          title="Aperçu du courrier"
          width="530"
          height="750"
          src={`${templateURL}#toolbar=0&navpanes=0&scrollbar=0`}
          type="application/pdf"
        />
      )}
    </Loading>
  );
};
